/* 迁移 '@home/components/GameImage';组件并作修改 for placeholder part
 */

import React from 'react'
import classnames from 'classnames';
import 'rc-image/assets/index.css';
import pcGameDefaultIcon from '@/pages/dashboard/assets/svg/pc-game-default.svg'
import mobileGameDefaultIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg'
import consoleGameDefaultIcon from '@/pages/dashboard/assets/svg/console-game-default.svg'
import Image from 'rc-image';
import GameDefault from '@/pages/home/assets/img/common/game-default.svg';
import CompanyDefault from '@/pages/home/assets/img/common/company-default.svg';
import PCGameDefault from '@/pages/home/assets/img/common/pcgame-default.png';
import ConsoleGameDefault from '@/pages/home/assets/img/common/consolegame-default.png';
import './index.scss';
import ImgLoading from '@/pages/home/assets/img/common/image-loading-new.png'; // old method
// import ImgLoading from '@/pages/home/assets/img/common/image-loading.png';
import SwiperDefault from '@/pages/home/assets/img/common/swiper-default.png';
import VideoDefault from '@/pages/home/assets/img/common/video-default.png';
import UserDefault from '@/pages/home/assets/img/common/user-default.svg';
import ReportDefault from '@/pages/home/assets/img/common/report-default.png';
import Loading from '@intelligence/components/Loading';
import { Bubble } from 'tea-component';

//全局统一图片加载组件
export default function GameImage(props: any) {
  const { entityType, src, style, className, alt, moduleType = 'home', onClick, key = '', bubbleContent = '' } = props;

  //根据图片类型返回默认图片，包括
  const getDefaultImg = (moduleType: string, entityType: string) => {
    switch (entityType) {
      case 'mobile':
        return moduleType == 'dashboard' ? mobileGameDefaultIcon : GameDefault;
      case 'pc':
        return moduleType == 'dashboard' ? pcGameDefaultIcon : PCGameDefault;
      case 'console':
      case 'combine':
        return moduleType == 'dashboard' ? consoleGameDefaultIcon : ConsoleGameDefault;
      case 'company':
        return moduleType == 'dashboard' ? CompanyDefault : CompanyDefault;
      case 'swipe':
        return SwiperDefault;
      case 'video':
      case 'background':
        return VideoDefault;
      case 'user':
        return UserDefault;
      case 'report':
        return ReportDefault;
      default:
        return moduleType == 'dashboard' ? mobileGameDefaultIcon : GameDefault;
    }
  }

  return (
    <>
      <Bubble dark content={bubbleContent}>
        <Image
          key={`video-thumb-${alt || key}`}
          className={classnames('dbi-game-image', className, {
            'dbi-game-image--company': entityType === 'company',
          })}
          src={src || getDefaultImg(moduleType, entityType)}
          // Change the loading 
          placeholder={
             <div className={classnames('dbs-game-image-placeholder', className)}>
              <Loading content="" style={{height: '100%'}} />
             </div>
          }
          preview={false}
          fallback={getDefaultImg(moduleType, entityType)}
          onClick={onClick}
          style={style}
          onError={(e: any) => {
            e.target.src = getDefaultImg(moduleType, entityType);
          }}
        />
      </Bubble>
    </>
  )
}
